var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { size: "large", spinning: _vm.loading } },
    [
      _vm.linkedinAccounts.length > 0
        ? _c("div", { staticClass: "account-manager" }, [
            _c("div", { staticClass: "header-section" }, [
              _c("h1", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("LinkedInAccountManager"))),
              ]),
              _c("p", { staticClass: "page-subtitle" }, [
                _vm._v(" " + _vm._s(_vm.$t("ManageDailyLimits")) + " "),
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.$t("LTDAccountTips"))),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "account-selector" },
              [
                _c("span", { staticClass: "selector-label" }, [
                  _vm._v(_vm._s(_vm.$t("SelectLinkedInAccount")) + ":"),
                ]),
                _c(
                  "a-select",
                  {
                    staticClass: "account-select",
                    on: { change: _vm.handleAccountChange },
                    model: {
                      value: _vm.selectedAccount,
                      callback: function ($$v) {
                        _vm.selectedAccount = $$v
                      },
                      expression: "selectedAccount",
                    },
                  },
                  _vm._l(_vm.linkedinAccounts, function (account, index) {
                    return _c(
                      "a-select-option",
                      { key: index, attrs: { value: index } },
                      [
                        _c("span", { staticClass: "account-option" }, [
                          _vm._v(" 🔗 "),
                          _c("span", { staticClass: "account-email" }, [
                            _vm._v(_vm._s(account.linkedin_email)),
                          ]),
                          _c("span", { staticClass: "campaign-badge" }, [
                            _vm._v(
                              " " +
                                _vm._s(account.running_campaign_count) +
                                " " +
                                _vm._s(_vm.$t("Campaigns"))
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "settings-card" }, [
              _c(
                "div",
                { staticClass: "settings-header" },
                [
                  _c(
                    "div",
                    { staticClass: "settings-title" },
                    [
                      _c("a-icon", {
                        staticClass: "settings-icon",
                        attrs: { type: "setting" },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("AccountSettings")))]),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      staticClass: "save-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.updateHandler },
                    },
                    [
                      _c("a-icon", { attrs: { type: "save" } }),
                      _vm._v(" " + _vm._s(_vm.$t("SaveChanges")) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "daily-limit-section" }, [
                _c("div", { staticClass: "limit-row" }, [
                  _c("span", { staticClass: "limit-label" }, [
                    _vm._v(_vm._s(_vm.$t("DailyConnectionRequestLimit")) + ":"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "limit-control" },
                    [
                      _c("limit-box", {
                        attrs: { value: _vm.dailyLimit, min: 1, max: 100000 },
                        on: { change: _vm.handleLimitChange },
                      }),
                      _c("span", { staticClass: "limit-unit" }, [
                        _vm._v(_vm._s(_vm.$t("requestsPerDay"))),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "limit-stats" }, [
                    _c(
                      "div",
                      { staticClass: "sent-today" },
                      [
                        _c(
                          "span",
                          { staticClass: "stat-item sent" },
                          [
                            _c("a-icon", {
                              staticClass: "stat-icon",
                              attrs: { type: "check-circle", theme: "filled" },
                            }),
                            _vm._v(" " + _vm._s(_vm.$t("SentToday")) + ": "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.linkedin_info.today_sent) +
                                  "/" +
                                  _vm._s(_vm.linkedin_info.request_limit)
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c("a-progress", {
                          staticClass: "limit-progress",
                          attrs: {
                            percent:
                              (_vm.linkedin_info.today_sent /
                                _vm.linkedin_info.request_limit) *
                              100,
                            "show-info": false,
                            "stroke-color": "#12B981",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "stat-item remaining" }, [
                      _vm._v(" 📅 " + _vm._s(_vm.$t("Remaining")) + ": "),
                      _c("strong", { staticStyle: { color: "#12b981" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.dailyLimit - _vm.linkedin_info.today_sent > 0
                              ? _vm.dailyLimit - _vm.linkedin_info.today_sent
                              : 0
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              !_vm.linkedinAccounts[this.selectedAccount].is_ltd
                ? _c(
                    "div",
                    { staticClass: "allocation-section" },
                    [
                      _c("h3", { staticClass: "section-title" }, [
                        _vm._v(_vm._s(_vm.$t("AllocationMode")) + ":"),
                      ]),
                      _c("allocation-options", {
                        attrs: {
                          allocationMode: _vm.allocationMode,
                          "daily-limit": _vm.dailyLimit,
                          "active-campaigns-count": _vm.campaignQueue.length,
                        },
                        on: { change: _vm.handleAllocationChange },
                      }),
                      _c("p", { staticClass: "switchTips" }, [
                        _vm._v(" " + _vm._s(_vm.$t("SwitchModeTips")) + " "),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.linkedinAccounts[this.selectedAccount].is_ltd
                ? _c(
                    "div",
                    { staticClass: "queue-section" },
                    [
                      _c("div", { staticClass: "queue-header" }, [
                        _c(
                          "div",
                          { staticClass: "queue-title" },
                          [
                            _c("a-icon", { attrs: { type: "ordered-list" } }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("CampaignExecutionQueue"))),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          { staticClass: "drag-hint" },
                          [
                            _c("a-icon", { attrs: { type: "drag" } }),
                            _vm._v(" " + _vm._s(_vm.$t("DragToReorder")) + " "),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "queue-table-header" }, [
                        _c(
                          "span",
                          {
                            staticClass: "col-queue",
                            staticStyle: { "text-align": "right" },
                          },
                          [_vm._v(_vm._s(_vm.$t("Queue")))]
                        ),
                        _c("span", { staticClass: "col-name" }, [
                          _vm._v(_vm._s(_vm.$t("CampaignName"))),
                        ]),
                        _c("span", { staticClass: "col-agent" }, [
                          _vm._v(_vm._s(_vm.$t("Agent"))),
                        ]),
                        _c("span", { staticClass: "col-active" }, [
                          _vm._v(_vm._s(_vm.$t("Active"))),
                        ]),
                        _c("span", { staticClass: "col-plan" }, [
                          _vm._v(_vm._s(_vm.$t("RemainingToday"))),
                        ]),
                        _c("span", { staticClass: "col-dayLimit" }, [
                          _vm._v(_vm._s(_vm.$t("UsedToday"))),
                        ]),
                      ]),
                      _c(
                        "draggable",
                        {
                          staticClass: "queue-list",
                          on: { end: _vm.handleDragEnd },
                          model: {
                            value: _vm.campaignQueue,
                            callback: function ($$v) {
                              _vm.campaignQueue = $$v
                            },
                            expression: "campaignQueue",
                          },
                        },
                        _vm._l(_vm.campaignQueue, function (campaign, index) {
                          return _c(
                            "div",
                            { key: campaign.id, staticClass: "queue-item" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-queue" },
                                [
                                  _c("a-icon", {
                                    staticClass: "drag-handle",
                                    attrs: { type: "drag" },
                                  }),
                                  _c("span", { staticClass: "queue-number" }, [
                                    _vm._v(_vm._s(index + 1)),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "col-name" }, [
                                _c("div", { staticClass: "campaign-info" }, [
                                  _c("span", { staticClass: "campaign-name" }, [
                                    _vm._v(_vm._s(campaign.campaign_name)),
                                  ]),
                                  _c("div", { staticClass: "campaign-meta" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("Created")) +
                                          ": " +
                                          _vm._s(campaign.create_time)
                                      ),
                                    ]),
                                    campaign.today_send_count &&
                                    campaign.campaign_friend_request_count <=
                                      campaign.today_send_count &&
                                    _vm.linkedin_info.allocation_mode == 1
                                      ? _c(
                                          "span",
                                          { staticClass: "remaining-badge" },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "team" },
                                            }),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("OnlyLeftToComplete", {
                                                  count:
                                                    campaign.campaign_friend_request_count,
                                                })
                                              ) + " "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    campaign.inherit_from_queue &&
                                    _vm.linkedin_info.allocation_mode == 1
                                      ? _c(
                                          "span",
                                          { staticClass: "surplus-badge" },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "arrow-up" },
                                            }),
                                            _vm._v(
                                              " +" +
                                                _vm._s(
                                                  campaign.today_send_count
                                                ) +
                                                " " +
                                                _vm._s(_vm.$t("fromCampaign")) +
                                                _vm._s(
                                                  campaign.inherit_from_queue
                                                ) +
                                                " "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticClass: "col-agent" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "agent-badge",
                                    class:
                                      campaign.campaign_type == 1
                                        ? "sales"
                                        : "recruiter",
                                  },
                                  [
                                    campaign.campaign_type == 1
                                      ? _c("span", [_vm._v("💼")])
                                      : _c("span", [_vm._v("🎯")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          campaign.campaign_type == 1
                                            ? _vm.$t("AISalesRepLabel")
                                            : _vm.$t("AIRecruiterLabel")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "col-active" },
                                [
                                  _c("a-switch", {
                                    on: {
                                      change: (val) =>
                                        _vm.toggleCampaign(campaign, val),
                                    },
                                    model: {
                                      value: campaign.status,
                                      callback: function ($$v) {
                                        _vm.$set(campaign, "status", $$v)
                                      },
                                      expression: "campaign.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.linkedin_info.allocation_mode == 1
                                ? _c("div", { staticClass: "col-plan" }, [
                                    campaign.send_status == 3
                                      ? _c(
                                          "span",
                                          { staticClass: "plan-needed" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("Done")) + " "
                                            ),
                                          ]
                                        )
                                      : index == 0 &&
                                        campaign.send_status != 3 &&
                                        campaign.today_send_count &&
                                        (campaign.today_send_count >=
                                          _vm.linkedin_info.request_limit ||
                                          campaign.today_send_count <=
                                            _vm.linkedin_info.request_limit)
                                      ? _c(
                                          "span",
                                          { staticClass: "plan-needed" },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  campaign.today_send_count
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : !campaign.inherit_from_queue &&
                                        campaign.today_send_count
                                      ? _c(
                                          "span",
                                          { staticClass: "plan-needed" },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  campaign.today_send_count
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : campaign.inherit_from_queue
                                      ? _c(
                                          "span",
                                          { staticClass: "plan-today" },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  campaign.today_send_count
                                                )
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("today")) +
                                                " "
                                            ),
                                            campaign.inherit_from_queue
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "surplus-from",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("SurplusFrom")
                                                      ) +
                                                        " #" +
                                                        _vm._s(
                                                          campaign.inherit_from_queue
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : campaign.send_status == 2 ||
                                        campaign.send_status == 4
                                      ? _c(
                                          "span",
                                          { staticClass: "plan-waiting" },
                                          [
                                            _c("strong", [_vm._v("—")]),
                                            _c("br"),
                                            _vm._v(
                                              _vm._s(
                                                campaign.send_status == 2
                                                  ? _vm.$t("WaitingInQueue")
                                                  : _vm.$t("PendingCrawl")
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _c("div", { staticClass: "col-plan" }, [
                                    campaign.send_status == 3
                                      ? _c(
                                          "span",
                                          { staticClass: "plan-needed" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("Done")) + " "
                                            ),
                                          ]
                                        )
                                      : campaign.send_status == 2 ||
                                        campaign.send_status == 4
                                      ? _c(
                                          "span",
                                          { staticClass: "plan-waiting" },
                                          [
                                            _c("strong", [_vm._v("—")]),
                                            _c("br"),
                                            _vm._v(
                                              _vm._s(
                                                campaign.send_status == 2
                                                  ? _vm.$t("WaitingInQueue")
                                                  : _vm.$t("PendingCrawl")
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "plan-needed" },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  campaign.today_send_count
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                  ]),
                              _c("div", { staticClass: "col-dayLimit" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(campaign.today_completed_count) +
                                    " "
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm.linkedin_info.allocation_mode === 1
                        ? _c(
                            "div",
                            { staticClass: "sequential-notice" },
                            [
                              _c("a-icon", {
                                staticClass: "notice-icon",
                                attrs: {
                                  type: "exclamation-circle",
                                  theme: "filled",
                                },
                              }),
                              _c("div", [
                                _c("div", { staticClass: "notice-header" }, [
                                  _c("span", { staticClass: "notice-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SequentialExecutionNotice")
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("p", { staticClass: "notice-content" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("SequentialNoticeContent1"))
                                  ),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("Queue")) + " #1"),
                                  ]),
                                  _vm._v(
                                    _vm._s(_vm.$t("SequentialNoticeContent2"))
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("SequentialNoticeContent3"))
                                    ),
                                  ]),
                                  _vm._v(
                                    _vm._s(_vm.$t("SequentialNoticeContent4")) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "notice-tip" }, [
                                  _vm._v(" 💡 "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("SequentialNoticeTip"))
                                    ),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.linkedin_info.allocation_mode === 2
                        ? _c(
                            "div",
                            { staticClass: "sequential-notice" },
                            [
                              _c("a-icon", {
                                staticClass: "notice-icon",
                                attrs: {
                                  type: "exclamation-circle",
                                  theme: "filled",
                                },
                              }),
                              _c("div", [
                                _c("div", { staticClass: "notice-header" }, [
                                  _c("span", { staticClass: "notice-title" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("EqualExecutionNotice"))
                                    ),
                                  ]),
                                ]),
                                _c("p", { staticClass: "notice-content" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("EqualNoticeContent")) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ])
        : _c("div", { staticClass: "nodata" }, [_c("a-empty")], 1),
      _vm.showModal
        ? _c("CampaignModalCon", {
            attrs: { showModal: _vm.showModal, newLinkedIn: _vm.newLinkedIn },
            on: {
              "update:showModal": function ($event) {
                _vm.showModal = $event
              },
              "update:show-modal": function ($event) {
                _vm.showModal = $event
              },
              saveLinkedIn: _vm.saveLinkedIn,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }